module.exports = __webpack_public_path__ + "fonts/selima-webfont.b4a11156.eot";